/**************************************************
 * Nombre:       Formulario_Lista_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import Tarjetas_Producto from "../Tarjetas/Tarjetas_Producto";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {theme} from "../../Tema";

const Formulario_Lista_Productos = ({...props}) => {
    const [productos, setProductos] = useState([])

    const obtenerValorTotal = (prods) => {


        let val = 0

        for (let i = 0; i < prods.length; i++) {
            val += prods[i].valor * prods[i].cantidad
        }
        return val

    }

    useEffect(() => {


        setProductos(props.props.getValues('productos'))

    }, [props.props.watch('productos')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        {productos.map((it, index) => {
                            return (
                                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                                    <Tarjetas_Producto item={it}/>
                                </Grid>
                            )
                        })}

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        // sx={{backgroundColor: 'pink'}}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}
                              sx={{mt: 1, pr: 2}}>
                            <Typography sx={{
                                fontSize: 18,
                                fontWeight: 700,
                                color: theme.palette.primary.main
                            }}>{`Valor Compra : ${formatoMoneda(obtenerValorTotal(productos))}`}</Typography>
                        </Grid>


                    </Grid>

                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Lista_Productos

